// packageService.js
import api from "./api";
import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:5000/api';

// Get auth token from localStorage
const getAuthHeader = () => {
  const token = localStorage.getItem('access_token');
  return {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
};

export const getAllPackageDetails = () => {
  return api.get("/package/getAllPackageDetails", {
    requiresAuth: true
  });
};

export const request_package = (form) => {
  return api.post("/package/requestPackage", form, {
    requiresAuth: false
  });
};

// Get Package by ID
export const getPackageById = async (packageId) => {
  try {
    const response = await axios.get(
      `${API_URL}/package/${packageId}`,
      getAuthHeader()
    );
    return response;
  } catch (error) {
    console.error('Error getting package by ID:', error);
    throw error;
  }
};

// Get all package requests
export const getAllRequests = async (status = null) => {
  try {
    let url = `${API_URL}/package/requests/all`;
    if (status) {
      url += `?status=${status}`;
    }
    const response = await axios.get(url, getAuthHeader());
    return response.data;
  } catch (error) {
    console.error('Error getting requests:', error);
    throw error;
  }
};

// Get request by ID
export const getRequestById = async (requestId) => {
  try {
    const response = await axios.get(
      `${API_URL}/package/requests/${requestId}`,
      getAuthHeader()
    );
    return response.data;
  } catch (error) {
    console.error('Error getting request by ID:', error);
    throw error;
  }
};

// Create package from request
export const createPackageFromRequest = async (data) => {
  try {
    const response = await axios.post(
      `${API_URL}/package/requests/create-package`,
      data,
      getAuthHeader()
    );
    return response.data;
  } catch (error) {
    console.error('Error creating package:', error);
    throw error;
  }
};

// Reject request
export const rejectRequest = async (data) => {
  try {
    const response = await axios.post(
      `${API_URL}/package/requests/reject`,
      data,
      getAuthHeader()
    );
    return response.data;
  } catch (error) {
    console.error('Error rejecting request:', error);
    throw error;
  }
};

// Get organization manager's custom package
export const getOrgManagerPackage = async (email) => {
  try {
    const response = await axios.get(
      `${API_URL}/package/org-manager/package/${email}`,
      getAuthHeader()
    );
    return response.data;
  } catch (error) {
    console.error('Error getting org manager package:', error);
    throw error;
  }
};